module.exports = __webpack_public_path__ + "static/media/4386.7cbe29a1.jpg";